/** 不常用和没用的computedStyle */
const ignoreComputedStyleKeys = [
    'accent-color',
    'anchor-name',
    'anchor-scope',
    'place-content',
    'place-items',
    'place-self',
    'alignment-baseline',
    'animation-composition',
    'animation-delay',
    'animation-direction',
    'animation-duration',
    'animation-fill-mode',
    'animation-iteration-count',
    'animation-name',
    'animation-play-state',
    'animation-range-end',
    'animation-range-start',
    'animation-timeline',
    'animation-timing-function',
    'animation',
    'app-region',
    'appearance',
    'backdrop-filter',
    'backface-visibility',
    'background-attachment',
    'baseline-shift',
    'baseline-source',
    'block-size',
    'border-block-end',
    'border-block-start',
    'border-end-end-radius',
    'border-end-start-radius',
    'border-inline-end',
    'border-inline-start',
    'border-start-end-radius',
    'border-start-start-radius',
    'border-block-end-color',
    'border-block-end-style',
    'border-block-end-width',
    'border-block-start-color',
    'border-block-start-style',
    'border-block-start-width',
    'border-inline-end-color',
    'border-inline-end-style',
    'border-inline-end-width',
    'border-inline-start-color',
    'border-inline-start-style',
    'border-inline-start-width',
    'box-decoration-break',
    'break-after',
    'break-before',
    'break-inside',
    'buffered-rendering',
    'caption-side',
    'caret-color',
    'clear',
    'clip',
    'clip-path',
    'clip-rule',
    'color-interpolation',
    'color-interpolation-filters',
    'color-rendering',
    'columns',
    'column-rule',
    'column-span',
    'column-count',
    'column-gap',
    'column-rule-color',
    'column-rule-style',
    'column-rule-width',
    'column-width',
    'contain-intrinsic-block-size',
    'contain-intrinsic-size',
    'contain-intrinsic-inline-size',
    'container',
    'contain-intrinsic-height',
    'contain-intrinsic-width',
    'container-name',
    'container-type',
    'content',
    'cursor',
    'direction',
    'dominant-baseline',
    'empty-cells',
    'field-sizing',
    'fill-opacity',
    'fill-rule',
    'filter',
    'float',
    'flood-color',
    'flood-opacity',
    'font-kerning',
    'font-optical-sizing',
    'font-palette',
    'font-stretch',
    'font-synthesis',
    'font-variant',
    'font-variant-emoji',
    'font-synthesis-small-caps',
    'font-synthesis-style',
    'font-synthesis-weight',
    'font-variant-alternates',
    'font-variant-caps',
    'font-variant-east-asian',
    'font-variant-ligatures',
    'font-variant-numeric',
    'font-variant-position',
    'grid',
    'grid-auto-columns',
    'grid-auto-flow',
    'grid-auto-rows',
    'grid-column-end',
    'grid-column-start',
    'grid-row-end',
    'grid-row-start',
    'grid-template-areas',
    'grid-template-columns',
    'grid-template-rows',
    'hyphenate-character',
    'hyphenate-limit-chars',
    'hyphens',
    'interpolate-size',
    'inset-block-end',
    'inset-block-start',
    'inset-inline-end',
    'inset-inline-start',
    'image-orientation',
    'image-rendering',
    'initial-letter',
    'inline-size',
    'inset-block',
    'inset-inline',
    'isolation',
    'list-style-image',
    'list-style-position',
    'lighting-color',
    'margin-block',
    'margin-inline',
    'margin-block-end',
    'margin-block-start',
    'margin-inline-end',
    'margin-inline-start',
    'marker-end',
    'marker-mid',
    'marker-start',
    'marker',
    'mask-clip',
    'mask-composite',
    'mask-image',
    'mask-mode',
    'mask-origin',
    'mask-position',
    'mask-repeat',
    'mask-size',
    'mask',
    'mask-type',
    'math-depth',
    'math-shift',
    'math-style',
    'max-block-size',
    'max-inline-size',
    'min-block-size',
    'min-inline-size',
    'mix-blend-mode',
    'offset',
    'offset-anchor',
    'offset-distance',
    'offset-path',
    'offset-position',
    'offset-rotate',
    'object-view-box',
    'order',
    'orphans',
    'outline',
    'outline-offset',
    'outline-color',
    'outline-style',
    'outline-width',
    'overflow-anchor',
    'overflow-clip-margin',
    'overflow-wrap',
    'overlay',
    'overscroll-behavior-block',
    'overscroll-behavior-inline',
    'padding-block-end',
    'padding-block-start',
    'padding-inline-end',
    'padding-inline-start',
    'padding-block',
    'padding-inline',
    'paint-order',
    'pointer-events',
    'position-anchor',
    'position-area',
    'position-try-fallbacks',
    'position-try-order',
    'position-visibility',
    'r',
    'row-gap',
    'resize',
    'ruby-position',
    'rx',
    'ry',
    'scroll-behavior',
    'scroll-initial-target',
    'scroll-margin-block',
    'scroll-margin-inline',
    'scroll-padding-block',
    'scroll-padding-inline',
    'scroll-timeline',
    'scroll-margin-block-end',
    'scroll-margin-block-start',
    'scroll-margin-inline-end',
    'scroll-margin-inline-start',
    'scroll-padding-block-end',
    'scroll-padding-block-start',
    'scroll-padding-inline-end',
    'scroll-padding-inline-start',
    'scroll-timeline-axis',
    'scroll-timeline-name',
    'scrollbar-color',
    'scrollbar-gutter',
    'scrollbar-width',
    'shape-image-threshold',
    'shape-margin',
    'shape-outside',
    'shape-rendering',
    'speak',
    'stop-color',
    'stop-opacity',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'tab-size',
    'text-align-last',
    'text-anchor',
    'text-decoration-skip-ink',
    'text-emphasis',
    'text-emphasis-position',
    'text-emphasis-color',
    'text-emphasis-style',
    'text-overflow',
    'text-rendering',
    'text-shadow',
    'text-size-adjust',
    'text-transform',
    'text-underline-position',
    'timeline-scope',
    'touch-action',
    'transform-style',
    'transition-behavior',
    'transition-delay',
    'transition-duration',
    'transition-property',
    'transition-timing-function',
    'translate',
    'unicode-bidi',
    'user-select',
    'vector-effect',
    'view-timeline-axis',
    'view-timeline-inset',
    'view-timeline-name',
    'view-transition-class',
    'view-transition-name',
    'white-space-collapse',
    'widows',
    'will-change',
    // '-webkit-border-horizontal-spacing',
    // '-webkit-border-vertical-spacing',
    // '-webkit-box-align',
    // '-webkit-box-decoration-break',
    // '-webkit-box-direction',
    // '-webkit-box-flex',
    // '-webkit-box-ordinal-group',
    // '-webkit-box-orient',
    // '-webkit-box-pack',
    // '-webkit-box-reflect',
    // '-webkit-font-smoothing',
    // '-webkit-line-clamp',
    // '-webkit-locale',
    // '-webkit-mask-box-image',
    // '-webkit-mask-box-image-outset',
    // '-webkit-mask-box-image-repeat',
    // '-webkit-mask-box-image-slice',
    // '-webkit-mask-box-image-source',
    // '-webkit-mask-box-image-width',
    // '-webkit-print-color-adjust',
    // '-webkit-rtl-ordering',
    // '-webkit-tap-highlight-color',
    // '-webkit-text-combine',
    // '-webkit-text-decorations-in-effect',
    // '-webkit-text-fill-color',
    // '-webkit-text-orientation',
    // '-webkit-text-security',
    // '-webkit-text-stroke-color',
    // '-webkit-text-stroke-width',
    // '-webkit-user-drag',
    // '-webkit-user-modify',

    // // 下面的是从safari的computedStyle中提取的多余的keys
    // '-apple-pay-button-style',
    // '-apple-pay-button-type',
    // '-webkit-backdrop-filter',
    // '-webkit-background-origin',
    // '-webkit-box-flex-group',
    // '-webkit-box-lines',
    // '-webkit-box-shadow',
    // '-webkit-column-axis',
    // '-webkit-column-progression',
    // '-webkit-cursor-visibility',
    // '-webkit-hyphenate-limit-after',
    // '-webkit-hyphenate-limit-before',
    // '-webkit-hyphenate-limit-lines',
    // '-webkit-initial-letter',
    // '-webkit-line-align',
    // '-webkit-line-box-contain',
    // '-webkit-line-grid',
    // '-webkit-line-snap',
    // '-webkit-mask-clip',
    // '-webkit-mask-composite',
    // '-webkit-mask-position-x',
    // '-webkit-mask-position-y',
    // '-webkit-mask-source-type',
    // '-webkit-nbsp-mode',
    // '-webkit-ruby-position',
    // '-webkit-text-zoom',
    // '-webkit-user-select',
];

const isAvailableComputedStyleKey = (key: string): boolean => {
    if (ignoreComputedStyleKeys.includes(key)) return false;
    // css变量也忽略 (safari下的computedStyle会多出一堆无用的css变量, 所以需要忽略)
    if (key.startsWith('--')) return false;
    // 以下的都是存在兼容问题的, 实际上不该使用, 也忽略
    if (key.startsWith('-webkit-') || key.startsWith('-moz-') || key.startsWith('-apple-')) return false;
    return true;
};

export default isAvailableComputedStyleKey;
